export function arrayEquals(a, b) {
    return Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((val, index) => val === b[index]);
}


export function getDistinctValues(obj_arr, key) {
    const distinct_values = new Set(obj_arr.map(o => o[key]))
    return Array.from(distinct_values)
}

export function generateColors(arr) {
    
    const to_return = Object()
    arr.forEach(k => {
        to_return[k] = [
            Math.random(),
            Math.random(),
            Math.random(),
        ]
    })
    return to_return
}

export function CmapAs255(cmap){
    const to_return = Object()
    Object.keys(cmap).forEach(k => {
        to_return[k] = [
            cmap[k][0],
            cmap[k][1],
            cmap[k][2]
        ]
    })
    return to_return
}